import Api from '@/services/Api'

const URL = 'cat/extensiones-telefonicas/';
const ACTION_ANULAR = 'anular'

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('pk' in params) {
            params.id = params.pk;
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    },
    update(id, data){
        return Api().put(`${URL}${id}/`, data);
    },
    anular(id) {
        return Api().post(`${URL}${id}/${ACTION_ANULAR}/`);
    }
}